import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '65px',
    marginBottom: '20px'
  },
  filters: {
    height: '32px',
    marginBottom: '34px',
    marginRight: '5px'
  },
  center: {
    height: '55px',
    marginBottom: '30px'
  },
  box: {
    height: '1069px'
  }
};

const SkeletonHotelLowRateCalendar = (props) => {
  const [className, style] = useStyles(props);
  const { header, filters, center, box } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="SkeletonHotelLowRateCalendar"
    >
      <Row gutters>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="12">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters={false}>
        <Col xs="1">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
        <Col xs="1">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="4" className="fr-mx-auto">
          <Box className="fr-skeleton-element" style={center} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={box} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonHotelLowRateCalendar.componentName = 'SkeletonHotelLowRateCalendar';

export default SkeletonHotelLowRateCalendar;
